import { CompanyData } from './../../../types/constants';

import kinzaBg from './../../../assets/img/kinza_bg.jpeg';
import { projects } from './projects';

export const kinza: CompanyData = {
  id: 5,
  name: 'Kinza Pvt Ltd',
  country: 'Sri Lanka',
  bg: kinzaBg,
  position: 'Internship',
  time: 'Jun 2015 - Dec 2015 (6 Months)',
  description:
    'The KINZA Group (Pvt.) Ltd is an IT service, consulting and business solutions company serving local and international businesses. I started my professional carrier as an intern at Kinza Group under my first-degree program',
  projects: projects,
};
